// extracted by mini-css-extract-plugin
export default {"VideoBreadcrumb":"VideoBreadcrumb--dQ3p6","breadcrumb":"breadcrumb--bw1t_"};